<div>
  <div class="mb-3">
    Your session will expire in <b>{{ countDownMinutes > 1 ? countDownMinutes + ' minutes' : countDownSeconds + ' seconds' }}.</b>
  </div>
  <div class="mb-4">
    <p-progressBar [value]="countDownPercent" [showValue]="false" />
  </div>
  <div class="d-flex justify-content-end">
    <button pButton severity="secondary" (click)="onClickLogout()">Log Out</button>
    <button pButton class="ms-3" (click)="onClickExtendSession()">Extend Session</button>
  </div>
</div>
